import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

export enum UpdateRecommendedAnswer {
  Yes = 'yes',
  No = 'no'
}

@Component({
  selector: 'mbs-update-recommended-modal',
  templateUrl: './update-recommended-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class UpdateRecommendedModalComponent {
  public readonly answer = UpdateRecommendedAnswer;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get question(): string {
    return this.baseModal.data?.question as string;
  }

  public respond(answer: UpdateRecommendedAnswer): void {
    this.baseModal.save(answer);
  }
}
